export { default } from "./TeacherToolsContent";
